import infoPopupFrameImg from './info_popup_frame.png';
import './InfoPopupFrame2.css';

export type InfoPopupFrame2Props = {
  titleSrc: string;
  bodySrc: string;
  titleClassName: string;
  bodyClassName: string;
  /** Closes when backdrop is pressed. */
  onClose?: () => void;
  className?: string;
  titleAlt?: string;
  bodyAlt?: string;
};

/**
 * From Figma info_popup_frame / clue_* (111 356.66 859×384.96) —
 * light-blue speech bubble + title/body SVG texts.
 */
export function InfoPopupFrame2({
  titleSrc,
  bodySrc,
  titleClassName,
  bodyClassName,
  onClose,
  className,
  titleAlt = '',
  bodyAlt = '',
}: InfoPopupFrame2Props) {
  return (
    <div
      className={['info-popup-frame-2-root', className].filter(Boolean).join(' ')}
      role="dialog"
      aria-modal="true"
      aria-label={titleAlt || undefined}
    >
      {onClose ? (
        <button
          type="button"
          className="info-popup-frame-2-root__backdrop"
          aria-label="Закрыть"
          onClick={onClose}
        />
      ) : null}
      <div className="info-popup-frame-2" aria-hidden={!titleAlt && !bodyAlt}>
        <img
          className="info-popup-frame-2__background"
          src={infoPopupFrameImg}
          alt=""
          draggable={false}
        />
        <img
          className={['info-popup-frame-2__title', titleClassName]
            .filter(Boolean)
            .join(' ')}
          src={titleSrc}
          alt={titleAlt}
          draggable={false}
        />
        <img
          className={['info-popup-frame-2__body', bodyClassName]
            .filter(Boolean)
            .join(' ')}
          src={bodySrc}
          alt={bodyAlt}
          draggable={false}
        />
      </div>
    </div>
  );
}
